import { Box, useMediaQuery } from '@mui/material';
import { theme } from '~/theme';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { TPurposeOfBusinessRelations } from '~/modules/identification/forms/BusinessRelations/types.ts';
import {
  EMPTY_INFO_CONTACTS,
  infoContactsTableColumns,
} from '~/modules/identification/forms/BusinessRelations/constants.ts';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion.tsx';
import { styles } from '../../styles';
import { TableHeader } from '~/components/ListCardTable/TableHeader.tsx';
import { InfoContactsTable } from '~/modules/identification/forms/BusinessRelations/components/InfoContacts/InfoContactsTable.tsx';
import { commonStyles } from '~/theme/styles/commonStyles';

export const DepositoryInfo = () => {
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { control, clearErrors, watch } = useFormContext<TPurposeOfBusinessRelations>();
  const isDepositoryInfoOnCapitalMarketsProvided = watch(
    'isDepositoryInfoOnCapitalMarketsProvided'
  );
  const { fields, append, remove, replace } = useFieldArray({
    control,
    name: 'depositoryInfoContacts',
  });

  const handleChangeDepositoryInfo = (isChecked: boolean) => {
    if (isChecked) {
      replace([EMPTY_INFO_CONTACTS]);
    } else {
      replace([]);
      clearErrors('depositoryInfoContacts');
    }
  };

  return (
    <>
      <FormYesNoQuestion
        name="isDepositoryInfoOnCapitalMarketsProvided"
        question={
          'Чи планується надавати інформацію щодо депозитарної діяльності на ринках капіталу?'
        }
        tooltipTitle={
          "Вкажіть контакти осіб, яким надаватиметься інформація щодо депозитарної діяльності. Дані передаватимуться відкритими каналами зв'язку (електронні комунікаційні мережі загального користування). Максимум 5 контактів"
        }
        onChange={handleChangeDepositoryInfo}
      />
      {isDepositoryInfoOnCapitalMarketsProvided && (
        <Box sx={styles.table}>
          {!isMobile && <TableHeader columns={infoContactsTableColumns} showActions />}
          <Box sx={{ ...commonStyles.columnFlexContainer, gap: { sm: 2, md: 0, xs: 2 } }}>
            {fields.map((field, index: number) => (
              <InfoContactsTable
                key={field.id}
                name={'depositoryInfoContacts'}
                index={index}
                showRemove={fields.length > 1}
                shownAppend={fields.length < 5}
                append={append}
                remove={remove}
              />
            ))}
          </Box>
        </Box>
      )}
    </>
  );
};
